import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';
import { NAV_ITEMS } from '../mock';
import { api } from '../api';

const PlixyLogo = ({ brandName }) => (
  <Link to="/" className="flex items-center gap-2 group">
    <div className="relative w-8 h-8">
      <div className="absolute inset-0 rounded-full plixy-gradient-ring" />
      <div className="absolute inset-[3px] rounded-full bg-white" />
      <div className="absolute inset-[7px] rounded-full plixy-gradient-ring opacity-90" />
    </div>

    <span className="text-2xl font-extrabold tracking-tight text-[#0a1930] group-hover:opacity-80 transition-opacity">
      {brandName}
    </span>
  </Link>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [brandName, setBrandName] = useState('IGGrowth');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await api.getPublicSettings();

        const name =
          settings?.brandName ||
          settings?.brand_name ||
          'IGGrowth';

        setBrandName(name);
      } catch (error) {
        console.error('Failed to load brand name:', error);
      }
    };

    loadSettings();
  }, []);

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="h-20 flex items-center justify-between">
          
          <PlixyLogo brandName={brandName} />

          <nav className="hidden lg:flex items-center gap-7">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm font-semibold text-slate-600 hover:text-[#0a1930] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/get-started"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-[#0a1930] text-white text-sm font-bold hover:opacity-90 transition-opacity"
            >
              Get Started
              <ChevronRight className="w-4 h-4" />
            </Link>
          </div>

          <button
            type="button"
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-5">
            <nav className="flex flex-col gap-2">
              {NAV_ITEMS.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="px-3 py-3 rounded-lg text-sm font-semibold text-slate-700 hover:bg-slate-50"
                >
                  {item.label}
                </a>
              ))}

              <Link
                to="/get-started"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center gap-1.5 px-5 py-3 rounded-full bg-[#0a1930] text-white text-sm font-bold"
              >
                Get Started
                <ChevronRight className="w-4 h-4" />
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
